import { render } from "./New.vue?vue&type=template&id=3ceb8c42&scoped=true"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3ceb8c42"

export default script